import React, { useCallback, useEffect, useState } from 'react';
import { getApiBaseUrl } from '../../../utils/apiConfig';
import { RichTextModal } from '../../process-config/components/DefeitosVerveRichTextModal';
import '../../process-config/components/DefeitosVerveRichTextModal.css';
import { normalizePolicyHtml } from '../utils/normalizePolicyHtml';

const API_BASE_URL = getApiBaseUrl();

const TAB_TERMO = 'termo';
const TAB_POLITICA = 'politica';

const POLITICAS_TABS = [
  { id: TAB_TERMO, label: 'Termo de uso' },
  { id: TAB_POLITICA, label: 'Política de privacidade' },
];

const EMPTY_DRAFTS = {
  [TAB_TERMO]: '',
  [TAB_POLITICA]: '',
};

export default function CustomersPoliticasModal({ open, onClose, onToastSuccess, onToastError }) {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState(TAB_TERMO);
  const [drafts, setDrafts] = useState(EMPTY_DRAFTS);

  const loadPolicies = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`${API_BASE_URL}/api/config/vc-sys-config/policies`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.message || 'Falha ao carregar políticas');
      }
      setDrafts({
        [TAB_TERMO]: normalizePolicyHtml(data.data?.termoUso || ''),
        [TAB_POLITICA]: normalizePolicyHtml(data.data?.politicaPrivacidade || ''),
      });
      setActiveTab(TAB_TERMO);
    } catch (e) {
      onToastError?.(e.message || 'Erro ao carregar políticas');
      onClose?.();
    } finally {
      setLoading(false);
    }
  }, [onClose, onToastError]);

  useEffect(() => {
    if (!open) return;
    loadPolicies();
  }, [open, loadPolicies]);

  const handleTabChange = useCallback((tabId, currentHtml) => {
    setDrafts((prev) => ({ ...prev, [activeTab]: normalizePolicyHtml(currentHtml) }));
    setActiveTab(tabId);
  }, [activeTab]);

  const handleSave = useCallback(
    async (currentHtml) => {
      const next = {
        ...drafts,
        [activeTab]: normalizePolicyHtml(currentHtml),
      };
      setDrafts(next);
      setSaving(true);
      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(`${API_BASE_URL}/api/config/vc-sys-config/policies`, {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            termo_uso: next[TAB_TERMO],
            politica_privacidade: next[TAB_POLITICA],
          }),
        });
        const data = await res.json();
        if (!res.ok || !data.success) {
          throw new Error(data.message || 'Falha ao salvar políticas');
        }
        setDrafts({
          [TAB_TERMO]: normalizePolicyHtml(data.data?.termoUso ?? next[TAB_TERMO]),
          [TAB_POLITICA]: normalizePolicyHtml(data.data?.politicaPrivacidade ?? next[TAB_POLITICA]),
        });
        onToastSuccess?.('Políticas de segurança atualizadas');
        onClose?.();
      } catch (e) {
        onToastError?.(e.message || 'Erro ao salvar políticas');
      } finally {
        setSaving(false);
      }
    },
    [activeTab, drafts, onClose, onToastError, onToastSuccess]
  );

  if (!open || loading) {
    if (!open) return null;
    return (
      <div className="defeitos-vv-modal-backdrop" role="presentation">
        <div className="defeitos-vv-rt-modal" role="dialog" aria-busy="true">
          <header className="defeitos-vv-rt-modal-head">
            <h1 className="defeitos-vv-rt-modal-title">Políticas de segurança</h1>
          </header>
          <div className="defeitos-vv-rt-scroll" style={{ padding: '1.5rem', color: '#71717a', fontSize: 13 }}>
            Carregando…
          </div>
        </div>
      </div>
    );
  }

  return (
    <RichTextModal
      open={open}
      title="Políticas de segurança"
      initialHtml={drafts[activeTab] || ''}
      tabs={POLITICAS_TABS}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      onClose={onClose}
      onSave={handleSave}
      saving={saving}
      normalizeHtml={normalizePolicyHtml}
    />
  );
}
